// extracted by mini-css-extract-plugin
export var chevronIcon = "_cm-2";
export var teamName = "_cm-1";
export var teamSwitcherButton = "_cm-0";